// extracted by mini-css-extract-plugin
export default {"ItemsList":"ItemsList_ItemsList__3kHWS"};